/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "landing_pad";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface LandingPadType {
}

export enum LandingPadType_Enum {
  INVALID = 0,
  CASE = 1,
  LOGO_DOCK = 4,
  APRILTAG_VESSEL = 5,
  APRILTAG_PEDESTAL_REV2 = 6,
  G47 = 7,
  UNRECOGNIZED = -1,
}

export function landingPadType_EnumFromJSON(object: any): LandingPadType_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return LandingPadType_Enum.INVALID;
    case 1:
    case "CASE":
      return LandingPadType_Enum.CASE;
    case 4:
    case "LOGO_DOCK":
      return LandingPadType_Enum.LOGO_DOCK;
    case 5:
    case "APRILTAG_VESSEL":
      return LandingPadType_Enum.APRILTAG_VESSEL;
    case 6:
    case "APRILTAG_PEDESTAL_REV2":
      return LandingPadType_Enum.APRILTAG_PEDESTAL_REV2;
    case 7:
    case "G47":
      return LandingPadType_Enum.G47;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LandingPadType_Enum.UNRECOGNIZED;
  }
}

export function landingPadType_EnumToJSON(object: LandingPadType_Enum): string {
  switch (object) {
    case LandingPadType_Enum.INVALID:
      return "INVALID";
    case LandingPadType_Enum.CASE:
      return "CASE";
    case LandingPadType_Enum.LOGO_DOCK:
      return "LOGO_DOCK";
    case LandingPadType_Enum.APRILTAG_VESSEL:
      return "APRILTAG_VESSEL";
    case LandingPadType_Enum.APRILTAG_PEDESTAL_REV2:
      return "APRILTAG_PEDESTAL_REV2";
    case LandingPadType_Enum.G47:
      return "G47";
    case LandingPadType_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseLandingPadType(): LandingPadType {
  return {};
}

export const LandingPadType = {
  encode(_: LandingPadType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LandingPadType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLandingPadType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): LandingPadType {
    return {};
  },

  toJSON(_: LandingPadType): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<LandingPadType>, I>>(base?: I): LandingPadType {
    return LandingPadType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LandingPadType>, I>>(_: I): LandingPadType {
    const message = createBaseLandingPadType();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
